











































import { Component, Prop } from 'vue-property-decorator'
import CardPanel from '@/components/common/CardPanel.vue'
import OperationResultTips from '@/components/common/OperationResultTips.vue'
import { TaskDetail } from '@/types/Task'
import { getSocket } from '@/socket.io'
import { PushDetail } from '@/types/Message'
import RouterHelper from '@/mixins/RouterHelper.vue'
import { RawLocation } from 'vue-router'

type pushProgress = {
  [key: string]: number
  // 后端推送格式 "20210706_105759_03748_0": 12
}

@Component({
  components: {
    CardPanel,
    OperationResultTips
  }
})
export default class TaskStatusTips extends RouterHelper {
  @Prop() taskDetail!: TaskDetail

  private jobId: string = ''
  private progress: number = 0
  private createTime: string = ''
  private type: string = 'running'
  private finishListener!: Function

  /**
   * 监听 websocket 消息, 处理完成跳转结果
   */
  private addSocketListener () {
    const socket = getSocket()
    if (!socket) return
    this.finishListener = (msgDetail: PushDetail) => {
      const resultRouteMap: { [key: string]: string } = {
        PreProcessing: `PreProcessingResult`,
        DataIntegration: `DataIntegrationResult`,
        Clustering: `ClusteringResult`,
        DifferentialExpression: `DifferentialExpressionResult`,
        CellTypeAnnotation: `CellTypeAnnotationResult`,
        TrajectoryAnalysis: `TrajectoryAnalysisResult`,
        AdvancedDownstreamAnalysis: `AdvancedDownstreamAnalysisResult`,
        GeneSetEnrichment: `GeneSetEnrichmentResult`,
        CellCommunication: `CellCommunicationResult`,
        InferCNV: `InferCNVResult`
      }
      const taskResultRoute: RawLocation = this.getCompleteRouteByPathObject({
        name: resultRouteMap[msgDetail.category],
        params: { id: msgDetail.id }
      })
      if (this.jobId === msgDetail.id && msgDetail.type === 'success') {
        this.type = 'success'
        setTimeout(() => { this.$router.push(taskResultRoute) }, 2000)
      }
      if (msgDetail.type === 'error') {
        this.type = msgDetail.type
      }
    }
    socket.on('job_finish', this.finishListener)

    socket.on('job_progress', (data: pushProgress) => {
      if (data.hasOwnProperty(this.jobId)) {
        this.progress = data[this.jobId]
      }
    })
  }

  mounted () {
    this.jobId = this.taskDetail.job_id
    this.createTime = this.taskDetail.create_time
    this.addSocketListener()
  }

  destroyed () {
    const socket = getSocket()
    socket.off('job_finish', this.finishListener)
    socket.off('job_progress')
  }
}
